import React from 'react';
import { LOANS } from '../data';

const Footer = ({ t }) => {
  const socialLinks = [
    { label: 'F',  href: '#' },
    { label: 'IN', href: '#' },
    { label: 'YT', href: '#' },
    { label: 'TW', href: '#' },
  ];

  const quickLinks = ['Home', 'Services', 'Features', 'Banks', 'Process', 'Contact'];

  const contactItems = [
    '+91 9634629999 || +91 9953252454',
    'info@futurefundfinance.in',
    'Mon–Sat 9AM–7PM',
    'All India Coverage',
  ];

  const legalLinks = ['Privacy Policy', 'Terms of Service', 'Disclaimer'];

  return (
    <footer
      style={{
        background: '#050505',
        padding: '80px 32px 40px',
        borderTop: '1px solid rgba(201,162,39,0.15)',
      }}
    >
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        {/* Grid */}
        <div
          className="footer-grid"
          style={{ display: 'grid', gridTemplateColumns: '2.5fr 1fr 1fr 1fr', gap: 48, marginBottom: 64 }}
        >
          {/* Brand */}
          <div>
            <div
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontWeight: 700, fontSize: 24,
                color: '#c9a227', marginBottom: 20,
              }}
            >
              Future Fund Finance
            </div>
            <p
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 15, color: 'rgba(255,255,255,0.35)',
                lineHeight: 1.8, maxWidth: 320, marginBottom: 28,
              }}
            >
              Your trusted partner for fast, transparent, and affordable loans across India.
              Empowering individuals, families, and businesses to achieve their financial goals.
            </p>
            <div style={{ display: 'flex', gap: 10 }}>
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  style={{
                    width: 38, height: 38, borderRadius: 8,
                    background: 'rgba(201,162,39,0.1)',
                    border: '1px solid rgba(201,162,39,0.2)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#c9a227', textDecoration: 'none',
                    fontSize: 13, fontWeight: 700,
                    fontFamily: "'DM Sans', sans-serif",
                    transition: 'all 0.3s',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(135deg,#c9a227,#e8c040)';
                    e.currentTarget.style.color = '#0a0a0a';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(201,162,39,0.1)';
                    e.currentTarget.style.color = '#c9a227';
                  }}
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontWeight: 700, color: '#c9a227', marginBottom: 22 }}>
              Services
            </h4>
            {LOANS.map((l) => (
              <a
                key={l.title}
                href="#services"
                style={{
                  fontFamily: "'DM Sans', sans-serif", fontSize: 14,
                  color: 'rgba(255,255,255,0.35)',
                  marginBottom: 10, display: 'block',
                  textDecoration: 'none', transition: 'color 0.2s',
                }}
                onMouseEnter={(e) => (e.target.style.color = '#c9a227')}
                onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.35)')}
              >
                {l.title}
              </a>
            ))}
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontWeight: 700, color: '#c9a227', marginBottom: 22 }}>
              Company
            </h4>
            {quickLinks.map((l) => (
              <a
                key={l}
                href={`#${l.toLowerCase()}`}
                style={{
                  fontFamily: "'DM Sans', sans-serif", fontSize: 14,
                  color: 'rgba(255,255,255,0.35)',
                  marginBottom: 10, display: 'block',
                  textDecoration: 'none', transition: 'color 0.2s',
                }}
                onMouseEnter={(e) => (e.target.style.color = '#c9a227')}
                onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.35)')}
              >
                {l}
              </a>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontWeight: 700, color: '#c9a227', marginBottom: 22 }}>
              Contact
            </h4>
            {contactItems.map((item) => (
              <div
                key={item}
                style={{
                  fontFamily: "'DM Sans', sans-serif", fontSize: 13,
                  color: 'rgba(255,255,255,0.35)',
                  marginBottom: 12, lineHeight: 1.5,
                }}
              >
                {item}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div
          style={{
            borderTop: '1px solid rgba(201,162,39,0.1)',
            paddingTop: 28,
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 12,
          }}
        >
          <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: 'rgba(255,255,255,0.2)' }}>
            © 2024 Future Fund Finance. All rights reserved. | RBI Compliant Loan Facilitator
          </div>
          <div style={{ display: 'flex', gap: 20 }}>
            {legalLinks.map((l) => (
              <a
                key={l}
                href="#"
                style={{
                  fontFamily: "'DM Sans', sans-serif", fontSize: 13,
                  color: 'rgba(255,255,255,0.2)',
                  textDecoration: 'none', transition: 'color 0.2s',
                }}
                onMouseEnter={(e) => (e.target.style.color = '#c9a227')}
                onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.2)')}
              >
                {l}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
